import { Directive, ElementRef, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import intlTelInput from 'intl-tel-input';

@Directive({
  selector: '[appIntlTelInput]',
  standalone: false
})
export class IntlTelInputDirective implements OnInit, OnDestroy {
  private iti: any;

  @Input() initialCountry: string = 'in';
  @Output() countryChange = new EventEmitter<string>();

  constructor(private el: ElementRef) {}

  ngOnInit() {
    const input = this.el.nativeElement;
    
    // Defensive initialization to handle different import patterns/global availability
    const initFn = (intlTelInput as any).default || intlTelInput || (window as any).intlTelInput;

    if (typeof initFn === 'function') {
      this.iti = initFn(input, {
        autoPlaceholder: 'off',
        initialCountry: this.initialCountry as any,
        separateDialCode: true,
        utilsScript: '/assets/js/utils.js'
      });
    } else {
      console.error('intlTelInput library not found or not a function');
    }

    if (this.iti) {
      input.addEventListener('countrychange', () => {
        const countryData = this.iti.getSelectedCountryData();
        if (countryData) {
          const dialCode = '+' + countryData.dialCode;
          input.setAttribute('data-dialcode', dialCode);
          this.countryChange.emit(dialCode);
        }
      });

      // Set initial dial code
      const initialData = this.iti.getSelectedCountryData();
      if (initialData) {
        input.setAttribute('data-dialcode', '+' + initialData.dialCode);
      }
    }
  }

  ngOnDestroy() {
    if (this.iti) {
      this.iti.destroy();
    }
  }
}
